import * as React from 'react'
import { ShopifyNext } from '@dotdev/next-components'
import { GlobalProps } from 'types'
import * as Snippets from 'snippets'
import { trackPromotionClick } from 'helpers'

export class SingleLineCTA extends React.PureComponent<SingleLineCTA.Props, SingleLineCTA.State> {
  public static sectionId = 'slcta';

  public render(): JSX.Element {
    const { section } = this.props
    const { settings } = section
    if (!settings) {
      return <React.Fragment />
    }

    let single_line_align_option_class = null
    let text_align_option_class = null
    if (settings.single_line_align_option_mobile === 'left') {
      single_line_align_option_class = 'justify-start'
      text_align_option_class = 'text-left'
    } else if (settings.single_line_align_option_mobile === 'center') {
      single_line_align_option_class = 'justify-center'
      text_align_option_class = 'text-center'
    } else {
      single_line_align_option_class = 'justify-end'
      text_align_option_class = 'text-right'
    }
    return (
      <section className={`dynamic-single-line-cta ${settings && settings.background ? `bg-${settings.background}` : ''}
        ${settings && settings.verticalspacing ? 'sm:mb-6-4 mb-1-6' : ''}`}>
        <div className={'max-w-7xl px-1-6 sm:px-2-4 2xl:px-22 xl:px-2-8 mx-auto py-1'}>
          <div className={`flex flex-wrap items-center ${single_line_align_option_class} lg:justify-center`}>
            <Snippets.Heading
              size={'p'}
              className={`pr-0-8 leading-close ${text_align_option_class}`}
              tag={'p'}
            >
              {settings.message}
            </Snippets.Heading>

            {settings?.linktext ? <Snippets.Button
              title={settings.linktext}
              onClick={() => trackPromotionClick(
                [{
                  id: section.id,
                  name: settings.message,
                  creative: 'Single line CTA'
                }],
                settings.linkurl
              )}
              colour={'blank'}
              className={'uppercase tracking-wider pt-0-4'}
            >
              <Snippets.Heading
                size={'h5'}
                tag={'p'}
              >
                {settings.linktext}
              </Snippets.Heading>
            </Snippets.Button> : null}
          </div>
        </div>
      </section>
    )
  }
}

export namespace SingleLineCTA {
  export type Options = ShopifyNext.Section<{
    verticalspacing: boolean;
    background: string;
    linktext: string;
    linkurl: string;
    message: string;
    single_line_align_option_mobile: string;
    single_line_align_option_class: string;
    text_align_option_class: string;
  }>;
  export interface Props extends GlobalProps {
    section: SingleLineCTA.Options;
  }
  export interface State { }
}
